import { useId } from 'react';

import { isYoutube, blurActiveElement } from '@/utils';

const TypeSelect = ({ value, source, options, disabled, onChange }) => {
  const masterId = useId();

  const id = `${masterId}TypeSelect`;

  const handleChange = (e) => {
    onChange(e.target.value);
    blurActiveElement();
  };

  if (isYoutube(source)) return null;

  return (
    <div className="input-group">
      <select
        id={id}
        value={value}
        disabled={disabled}
        className="form-select"
        onChange={handleChange}
      >
        <option value="">Transfer...</option>
        <option value={options.all}>Transfer ALL playlists</option>
        <option value={options.selection}>SELECT playlists to transfer</option>
      </select>
    </div>
  );
};

export default TypeSelect;
